module.exports = __webpack_public_path__ + "static/flags/UV-131605d9eab980eeb6c98e80a61c1423.gif";